import type { ExperienceMode, UserUiPreferences } from '@localagent/sdk';

export function resolveExperienceMode(
  stored: UserUiPreferences | { experience_mode?: unknown } | null | undefined,
): ExperienceMode {
  if (stored == null || stored.experience_mode == null) {
    return 'normal';
  }
  if (stored.experience_mode === 'normal' || stored.experience_mode === 'advanced') {
    return stored.experience_mode;
  }
  throw new Error(`illegal experience_mode: ${String(stored.experience_mode)}`);
}
